import React from 'react';
import { Box, Card, CardContent, Grid, IconButton, Typography, useTheme } from '@mui/material';
import {
  Assignment,
  ChevronRight as ArrowIcon,
  Warning,
  CheckBox,
  FactCheck,
  Build,
  EventBusy,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {
  PageHeader,
} from '../../components/SharedPageParts';

interface DashboardCard {
  title: string;
  subtitle: string;
  icon: React.ReactElement;
  iconBg: string;
  stats?: { label: string; value: number }[];
  action?: { label: string; onClick: () => void };
  path: string;
}
const preChecksandFormsCards: DashboardCard[] = [
    {
      title: 'SMART FLHA',
      subtitle: 'Field Level Hazard Assessments templates',
      icon: <Warning sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      stats: [
         //{ label: 'Active', value: 3 },
         //{ label: 'Total', value: 3 },
      ],
      path: '/prechecksandforms/flha',
    },
    {
      title: 'Equipment Pre Check',
      subtitle: 'Pre/Post equipment inspection questions',
      icon: <FactCheck sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      stats: [
         //{ label: 'Active', value: 2 },
         //{ label: 'Total', value: 2 },
      ],
      path: '/prechecksandforms/equipmentprecheck',
    },
    {
      title: 'Breakdown Reasons',
      subtitle: 'Equipment Failure categories and severities',
      icon: <Build sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      stats: [
         //{ label: 'Active', value: 3 },
         //{ label: 'Total', value: 3 },
      ],
      path: '/prechecksandforms/equipmentbreakdown',
    },
    {
      title: 'Non Productive Time',
      subtitle: 'Downtime reasons and categories',
      icon: <EventBusy sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      stats: [
         //{ label: 'Active', value: 3 },
         //{ label: 'Total', value: 3 },
      ],
      path: '/prechecksandforms/nptreasons',
    }
];
const PreChecksandFormsPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: theme.palette.background.default }}>
            {/* Main Content */}
            <Box className="MuiBox-root-margin" sx={{ px: 1, mx: 'auto' }}>
              <PageHeader
                                title="Pre Checks and Forms"
                                Icon={Assignment}
                                onBack={() => navigate('/')}
                                backLabel="Back to Dashboard"
                                subtitle="Configure safety checklist, equipment inspections, and tracking systems"
                              />
            
              <Grid container spacing={3}>
                {preChecksandFormsCards.map((card, index) => (
                  <Grid item xs={6} key={index}>
                    <Card
                      sx={{
                        height: '100%',
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        border: `1px solid ${theme.palette.divider}`,
                        '&:hover': { transform: 'translateY(-4px)', boxShadow: theme.palette.mode === 'light' ? '0 12px 24px rgba(0,0,0,0.1)' : '0 12px 24px rgba(0,0,0,0.3)' },
                      }}
                      onClick={() => navigate(card.path)}
                    >
                      <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                          <Box sx={{ width: 56, height: 56, borderRadius: 2, background: card.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: theme.palette.text.primary }}>
                            {card.icon}
                          </Box>
                          <IconButton size="small" sx={{ color: theme.palette.text.secondary }}>
                            <ArrowIcon />
                          </IconButton>
                        </Box>
      
                        <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 600, mb: 1 }}>
                          {card.title}
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.text.primary, mb: 2, flexGrow: 1 }}>
                          {card.subtitle}
                        </Typography>
      
                        {card.stats && (
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {card.stats.map((stat, i) => (
                              <Box key={i} sx={{ backgroundColor: theme.palette.background.default, px: 2, py: 1, borderRadius: 1, flex: '1 1 auto', minWidth: 60 }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }}>
                                  {stat.label}
                                </Typography>
                                <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 700 }}>
                                  {stat.value}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
      
                        {card.action && (
                          <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #475569' }}>
                            <Typography
                              variant="body2"
                              sx={{ color: '#667eea', fontWeight: 600, cursor: 'pointer' }}
                              onClick={(e) => { e.stopPropagation(); card.action?.onClick(); }}
                            >
                              {card.action.label}
                            </Typography>
                          </Box>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
            <Box sx={{ backgroundColor: '#29374dff', borderRadius: 2, p:1, mt:4 }}>
                    <Typography variant="h5" sx={{mt:4, mb:2, pl:1, color: theme.palette.text.primary}}><CheckBox /> About Pre Checks and Forms</Typography>
                    <Typography variant="body2" sx={{mt:2, mb:1, pl:1, color: theme.palette.text.secondary}}>
                    Pre checks and forms enables comprehensive safety and operational tracking for mining operations.
                    Configure customizabe checklists and tracking systems that field operators will use daily to ensure safety compliance,
                    equipment readiness, operational efficiency.
                    </Typography>
            </Box>
        </Box>
    );
};
export default PreChecksandFormsPage;